<template>
  <div class="delivery" v-if="pageRedy">
    <!-- 角色tab -->
    <div class="delivery-roles">
      <div
        class="delivery-role"
        v-for="role in rolesList"
        :key="role.id"
        @click="handleRoleClick(role)"
        :class="{ active: role.active }"
      >
        <img
          :src="imgList[role.type][role.active ? 'active' : 'default']"
          alt="icon.png"
        />
        <p>{{ role.category_name }}</p>
      </div>
    </div>

    <!-- 状态切换 -->
    <tab custom-bar-width="50px" active-color="rgb(140, 198, 63)">
      <tab-item selected @on-item-click="ontabClick('active')">未完成</tab-item>
      <tab-item @on-item-click="ontabClick('complete')">已完成</tab-item>
    </tab>

    <!-- 列表 -->
    <div class="delivery-list">
      <div
        class="delivery-item"
        v-for="article in articleList"
        :key="article.id"
        :class="{ 'no-expand': !article.expand }"
      >
        <img
          class="delivery-item-icon"
          :src="visible === 'active' ? iconList.off : iconList.on"
          alt="check-off"
          @click="toogleStatus(article)"
        />
        <div class="delivery-item-content">
          <p class="title">
            {{ article.article_title }}
            <img
              class="delivery-item-tag"
              src="@/assets/delivery/tag.png"
              alt="tag.png"
            />
            {{ article.resp_desc }}
          </p>
          <p class="content" @click="handleExpand(article)">
            <span v-html="article.article_content"></span>
            <img
              class="delivery-item-arrow"
              src="@/assets/delivery/arrow-down.png"
              alt="arrow-down.png"
            />
          </p>
        </div>
      </div>

      <!--加载框-->
      <vux-load-more
        :tip="loadMore.tip"
        v-show="loadMore.show"
        :show-loading="!loadMore.isDone"
      ></vux-load-more>
    </div>

    <!--暂无数据-->
    <no-data v-if="showNoData" :text="NodDataText"></no-data>

    <!--banner-->
    <!-- <div class="delivery-banner" @click="handleBannerClick">
      <img src="@/assets/delivery/banner.png" alt="banner.png">
    </div> -->
  </div>
</template>

<script>
import { Tab, TabItem } from "vux/src/components/tab";
import VuxLoadMore from "vux/src/components/load-more";
import NoData from "./component/NoData";
import { getRoleList, getArticleList, postToogleStatus } from "./api/index";
import { setupWXShare } from "@/helpers";
import { loadScript } from "@/load.js";

const TIPS = {
  loading: "正在加载",
  done: "我是有底线的～",
};
export default {
  name: "Delivery",
  components: {
    Tab,
    VuxLoadMore,
    TabItem,
    NoData,
  },
  data() {
    return {
      rolesList: [],
      imgList: {
        mum: {
          active: require("@/assets/delivery/icon-mom.png"),
          default: require("@/assets/delivery/icon-mom-outline.png"),
        },
        baby: {
          active: require("@/assets/delivery/icon-baby.png"),
          default: require("@/assets/delivery/icon-baby-outline.png"),
        },
      },
      list: {
        active: {
          params: {
            size: 20,
          },
          articleList: [],
        },
        complete: {
          params: {
            size: 20,
          },
          articleList: [],
        },
      },
      visible: "active",
      loadMore: {
        show: false,
        isFetching: false,
        isDone: false,
        tip: TIPS.loading,
      },
      pageRedy: false,
      iconList: {
        on: require("@/assets/delivery/icon-checkbox-on.png"),
        off: require("@/assets/delivery/icon-checkbox-off.png"),
      },
    };
  },
  computed: {
    currentRole() {
      return this.rolesList.find((r) => r.active);
    },
    articleList() {
      return this.currentArticle.articleList;
    },
    currentArticle() {
      return this.list[this.visible];
    },
    showNoData() {
      return (
        !this.currentArticle.articleList.length && !this.loadMore.isFetching
      );
    },
    NodDataText() {
      return this.visible === "active"
        ? "您的待产包暂未完成的内容～～"
        : "您的待产包暂无完成的内容～～";
    },
    // serve需要的字段
    activeStatus() {
      return this.visible === "active" ? 2 : 1;
    },
  },
  created() {
    setTimeout(() => {
      this.initWxShare();
    });
    loadScript();
    this.fetchData();
  },

  mounted() {
    document.title = "待产包";
  },

  methods: {
    async fetchData() {
      try {
        const rolesData = await getRoleList();
        this.rolesList = rolesData.data.data.map((r) => enrichRole(r));

        this.fetchArticle();
      } catch (e) {
        console.log(e);
      }

      function enrichRole(data) {
        const result = Object.assign({}, data);
        // 默认选中待产妈妈
        result.active = data.type === "mum";
        return result;
      }
    },

    fetchArticle() {
      const { id } = this.currentRole;
      const article = this.list[this.visible];
      // 请求下一页的时候，需要携带列表最后一项
      article.params.id =
        article.articleList[article.articleList.length - 1]?.id;

      this.loadMore.isFetching = true;
      this.loadMore.show = true;
      getArticleList({ cid: id, status: this.activeStatus, ...article.params })
        .then((res) => {
          const data = res.data.data.map(enrichArticle);
          if (!data.length) {
            this.loadMore.isDone = true;
            this.loadMore.tip = TIPS.done;
            return false;
          } else {
            this.loadMore.isDone = false;
            this.loadMore.tip = TIPS.loading;
            this.loadMore.show = false;
          }
          article.articleList = [...article.articleList, ...data];

          function enrichArticle(aArticle) {
            const result = Object.assign({}, aArticle);
            result.expand = false;
            return result;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loadMore.isDone = true;
        })
        .finally(() => {
          this.loadMore.show = false;
          this.loadMore.isFetching = false;
          this.pageRedy = true;
          this.$nextTick(() => {
            this.listenScroll();
          });
        });
    },

    handleRoleClick(aRole) {
      if (aRole.active) {
        return false;
      }
      aRole.active = true;
      this.rolesList.forEach((r) => {
        if (r !== aRole) {
          r.active = false;
        }
      });
      this.resetData();
      this.fetchArticle();
    },

    ontabClick(aStatus) {
      this.visible = aStatus;

      this.resetData();
      this.fetchArticle();
    },

    listenScroll() {
      const el = document.querySelector(".delivery");
      const _this = this;
      el.onscroll = function(e) {
        const scrollTop = e.target.scrollTop;
        const offsetHeight = e.target.offsetHeight;
        const scrollHeight = e.target.scrollHeight;
        const threshold = 40;

        console.log(scrollTop, offsetHeight, scrollHeight);
        if (scrollTop + offsetHeight + threshold >= scrollHeight) {
          _this.pullUp();
        }
      };
    },
    pullUpWhenDelete() {
      const el = document.querySelector(".delivery");
      const scrollTop = el.scrollTop;
      const offsetHeight = el.offsetHeight;
      const scrollHeight = el.scrollHeight;
      const threshold = 40;
      if (scrollTop + offsetHeight + threshold >= scrollHeight) {
        this.pullUp();
      }
    },

    pullUp() {
      if (this.loadMore.isFetching || this.loadMore.isDone) return false;
      this.loadMore.show = false;
      this.fetchArticle();
    },
    resetData() {
      this.loadMore = {
        show: false,
        isFetching: false,
        isDone: false,
        tip: TIPS.loading,
      };
      this.list = {
        active: {
          params: {
            size: 20,
          },
          articleList: [],
        },
        complete: {
          params: {
            size: 20,
          },
          articleList: [],
        },
      };
    },
    handleExpand(aArticle) {
      aArticle.expand = !aArticle.expand;
    },

    toogleStatus(aArticle) {
      const list = this.list[this.visible].articleList;
      list.splice(list.indexOf(aArticle), 1);
      postToogleStatus({
        articleId: aArticle.id,
        op: this.visible === "active" ? "add" : "dec",
      })
        .then((res) => {
          const toastText =
            this.visible === "active" ? "已标记为已完成" : "已标记为未完成";
          this.$toast.text(toastText, "default");
          console.log(res);
          this.pullUpWhenDelete();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    initWxShare() {
      setupWXShare({
        title: "待产包",
        wShareDesc: "史上最全的待产包清单",
        link: encodeURIComponent(window.location.href),
        imgUrl:
          "http://101file.doctopia.com.cn/1574328236764Fda89LMT4oNa8BpcNirDPAel.png",
        type: "link",
        dataUrl: "",
      });
    },

    handleBannerClick() {
      const b = window.__oneLiteBridge;
      const url = "https://j.youzan.com/ux59qM";
      if (b && b.connected) {
        b.navigateUrl(url);
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="scss">
.delivery {
  @import "../Eating/styles/index.scss";
  $theme-color: rgb(140, 198, 63);
  background-color: #fff;
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  padding-bottom: pxTOvw(120px);

  &-roles {
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    margin: pxTOvw(40px);
  }

  &-role {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    color: #aaa;
    font-size: pxTOvw(32px);
    padding: pxTOvw(24px) 0;

    &.active {
      color: $theme-color;
    }

    &:first-child {
      position: relative;

      &::after {
        content: "";
        width: 1px;
        height: pxTOvw(40px);
        background-color: #dddddd;
        position: absolute;
        right: 0;
      }
    }

    img {
      width: pxTOvw(60px);
      margin-right: pxTOvw(13px);
    }
  }

  .vux-tab-wrap {
    margin: 0 pxTOvw(33px);
  }

  &-list {
  }

  &-item {
    margin: 0 pxTOvw(33px);
    padding: pxTOvw(28px) 0;
    border-bottom: 1px solid #eeeeee;

    &-icon {
      width: pxTOvw(50px);
      height: pxTOvw(50px);
      margin-right: pxTOvw(16px);
      float: left;
    }

    &-content {
      color: #868686;
      font-size: pxTOvw(28px);
      margin-left: pxTOvw(60px);

      .title {
        color: #333333;
        font-size: pxTOvw(35px);
        line-height: pxTOvw(50px);
      }

      .content {
        position: relative;
        padding-right: 1em;
        text-align: justify;
        margin-left: 2px;
        img {
          transform: rotate(180deg);
        }
      }
    }

    &-tag {
      width: pxTOvw(67px);
      margin-left: pxTOvw(10px);
      vertical-align: -2px;
    }

    &-arrow {
      width: pxTOvw(30px);
      position: absolute;
      right: 0;
      bottom: 0.2em;
    }

    &.no-expand {
      .content {
        overflow: hidden;
        height: 1.4em;
        line-height: 1.4em;
        padding-right: 1.2em;
      }

      .delivery-item-arrow {
        transform: rotate(0deg);
      }
    }
  }

  &-banner {
    display: inline-block;
    font-size: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    img {
      width: 100%;
    }
  }

  .vux-tab-ink-bar {
    height: pxTOvw(4px) !important;
  }
}
</style>
